// extracted by mini-css-extract-plugin
export default {"root":"_238uy","flex":"_170s2","logout":"_2DGk2","iconLink":"_3sdgL","mobileTitle":"_3Eucb","desktopTitle":"_3osG6"};